<template>
  <div class="login-wrapper d-flex justify-content-center align-items-center min-vh-100">
    <div class="card shadow-lg rounded-4 p-4 bg-white bg-opacity-75" style="max-width: 400px; width: 100%;">
      <div class="card-body">
        <h3 class="text-center mb-4">Admin Login</h3>
        <form @submit.prevent="handleLogin">
          <div class="mb-3">
            <label for="username" class="form-label">Username</label>
            <input
              v-model="form.username"
              type="text"
              id="username"
              class="form-control"
              :class="{ 'is-invalid': errors.username }"
              required
            />
            <div class="invalid-feedback">{{ errors.username }}</div>
          </div>

          <div class="mb-3">
            <label for="password" class="form-label">Password</label>
            <input
              v-model="form.password"
              type="password"
              id="password"
              class="form-control"
              :class="{ 'is-invalid': errors.password }"
              required
            />
            <div class="invalid-feedback">{{ errors.password }}</div>
          </div>

          <button class="btn btn-success w-100" type="submit">Login</button>

          <div v-if="errorMessage" class="alert alert-danger mt-3 text-center">
            {{ errorMessage }}
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'

const router = useRouter()

const form = reactive({
  username: '',
  password: ''
})

const errors = reactive({
  username: '',
  password: ''
})

const errorMessage = ref('')

const validate = () => {
  errors.username = !form.username ? 'Username is required' : ''
  errors.password = !form.password ? 'Password is required' : ''
  return !errors.username && !errors.password
}

const handleLogin = async () => {
  if (!validate()) return

  try {
    const response = await axios.post('https://metatekapps.metateknologi.com/api-vms-adminauth.php', {
      username: form.username,
      password: form.password
    })

    const token = response.data.token
    localStorage.setItem('token', token)
    localStorage.setItem('username', form.username)
    router.push('/dashboard')
  } catch (err) {
    errorMessage.value = err.response?.data?.message || 'Login gagal. Coba lagi.'
  }
}
</script>

<style scoped>
.login-wrapper {
  background: url('https://images.unsplash.com/photo-1521791055366-0d553872125f?auto=format&fit=crop&w=1350&q=80') no-repeat center center;
  background-size: cover;
}
.card {
  backdrop-filter: blur(8px);
}
</style>
